import { render, staticRenderFns } from "./MyPageNewsStory.vue?vue&type=template&id=30485c68&scoped=true&"
import script from "./MyPageNewsStory.vue?vue&type=script&lang=js&"
export * from "./MyPageNewsStory.vue?vue&type=script&lang=js&"
import style0 from "./MyPageNewsStory.vue?vue&type=style&index=0&id=30485c68&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30485c68",
  null
  
)

export default component.exports